import fred from '../img/leadership/fred.jpg';
import fredwebp from '../img/leadership/fred.webp';
import justin from '../img/leadership/justin.jpg';
import justinwebp from '../img/leadership/justin.webp';
import pat from '../img/leadership/pat.jpg';
import patwebp from '../img/leadership/pat.webp';
import samir from '../img/leadership/samir.jpg';
import samirwebp from '../img/leadership/samir.webp';
import troy from '../img/leadership/troy.jpg';
import troywebp from '../img/leadership/troy.webp';

const leadershipList = {
  troy: {
    name: 'Troy Barnes',
    title: 'Executive Chairman',
    about:
      "Troy Barnes serves as Executive Chairman of RRDS INC, overseeing the company's financial operations, Corporate Development, and Strategic initiatives. Since joining RRDS in January 2014, Troy has played a pivotal role in driving growth and fostering innovation across the organization.<br/><br/>With a career spanning over four decades in technology manufacturing and distribution, including 10 years of experience in federal contracting, Troy brings a wealth of expertise to RRDS. He founded Kelly Micro Systems in 1984, later holding key leadership positions at Millennium Memory from 1994 to 2000, where he led operations, major accounts, and product development research. From 2001 to 2009, he served as CEO of Cheetah Electronics, a prominent technology company.<br/><br/>A Southern California native, born in San Diego and raised in Laguna Beach, Troy has been recognized for his entrepreneurial achievements, including being named a two-time finalist for Inc. Magazine's “Entrepreneur of the Year” in 1990 and 1991.<br/><br/>Troy is a dedicated family man, happily married for over 30 years, and a proud father of four adult children. An active individual, his hobbies include swimming, skiing, golf, and mountain biking.<br/><br/>Troy's leadership combines strategic vision and operational expertise, ensuring RRDS remains at the forefront of innovation and success.",
    image: './img/leadership/troy.jpg',
    imagewebp: './img/leadership/troy.webp',
    mail: 'mailto:troy.barnes@rrds.com',
  },
  samir: {
    name: 'Samir Naqvi',
    title: 'CEO',
    about:
      'In January 2024, Samir Naqvi assumed the role of Chief Executive Officer (CEO) at RRDS. Having previously served as the President of the company since January 2014, Samir’s dedication and leadership have been instrumental in driving RRDS towards unprecedented success.<br/><br/>Throughout his tenure as President, Samir has demonstrated a keen acumen for steering the company towards growth, consistently exceeding sales targets, and implementing innovative strategies. His commitment to upholding the company’s core values and brand identity has been unwavering, creating a foundation for sustained success.<br/><br/>Samir’s professional journey is underscored by a wealth of experience in the defense industry, where he has held various positions, showcasing a strong background in program management, unique supply chain management skills, and an in-depth understanding of logistics. His pivotal role in structuring complex Joint Ventures (JVs) and establishing strategic partnerships and teaming agreements has resulted in RRDS securing over $1 billion in Government funding through various Indefinite Delivery Indefinite Quantity (IDIQ) contracts and Task Orders.<br/><br/>Beyond his contributions to RRDS, Samir is a seasoned entrepreneur and co-founder of Avant Garde Imports, a leading innovator in the food and beverage industry. Drawing on his financial expertise gained from Fortune 50 companies like Citigroup and Barclays, he brings a unique perspective to the business landscape.<br/><br/>Born in Hong Kong and raised in diverse cultural environments, Samir’s international background has shaped his ability to cultivate long-lasting business relationships on a global scale. His commitment extends beyond the corporate realm, as evidenced by his active involvement in community and welfare activities. In his free time, Samir serves on the board of the non-profit organization Pity 4 Paws and is affiliated with the Wounded Warrior Project, showcasing a strong dedication to social causes.<br/><br/>As the newly appointed CEO, Samir Naqvi is poised to guide RRDS to new heights, leveraging his extensive experience, strategic vision, and unwavering dedication to excellence.',
    image: './img/leadership/samir.jpg',
    imagewebp: './img/leadership/samir.webp',
    mail: 'mailto:samir.naqvi@rrds.com',
  },
  fred: {
    name: 'Fred Bouman',
    title: 'President',
    about:
      'As President of RRDS, Mr. Bouman leads the company with a strategic focus on Federal Government sales and program management, ensuring unified collaboration with customers, suppliers, and end users across the globe.<br/><br/>His guidance is instrumental in facilitating the rapid delivery of mission-critical operational gear to the United States and global Allies. With extensive experience in the Defense Industry, Fred possesses a comprehensive understanding of business development, proposal management, contract execution, Federal Acquisition Regulation, international logistics and export compliance, global mission support services, corporate operations, and employee development. Through thousands of successful contract performances, Fred maintains strong relationships with key contracting offices and end users within the General Services Administration, Department of State, Department of Defense, and Department of Justice.<br/><br/>A graduate of the University of California, Irvine, where he studied International Relations and Political Science, Fred’s dedication to public service is evident throughout his career. His diverse background includes political consulting, criminal investigations, and personnel management before transitioning into the Defense Industry over a decade ago.<br/><br/>Beyond his professional achievements, Fred places a high value on family, friends, and community. As President, he emphasizes the importance of maintaining a healthy work-life balance and cherishing quality family time. Fred’s commitment to community extends beyond his role at RRDS, with a history of active involvement in community leadership positions. His well-rounded perspective, commitment to excellence, and dedication to both professional and personal aspects make him an exemplary leader at the helm of RRDS.',
    image: './img/leadership/fred.jpg',
    imagewebp: './img/leadership/fred.webp',
    mail: 'mailto:fred.bouman@rrds.com',
  },
  justin: {
    name: 'Justin Kast',
    title: 'Chief Financial Officer',
    about:
      'Joining in September of 2022, Justin S. Kast serves as the Chief Financial Officer at RRDS. He is responsible for the administrative, financial, and risk management operations within the company. Justin leads the development of our financial strategies, KPIs, and  monitors the company’s financial system. He is a strong believer in design management which brings a unique perspective to the team.<br/><br/>Prior to joining RRDS, Justin acquired a vast array of experience performing duties in Human Resources and IT Management, all while managing financial and accounting departments across multiple industries, including aerospace and composite manufacturing. While working full-time Justin earned his Master of Business Administration Degree in May of 2019 from California State University, Fullerton. In addition, to his MBA, he also holds a Bachelor’s degree in Accounting and a minor in Economics. His work and education experience enhances his hands-on approach to problem solving.<br/><br/>Born and raised in Southern California, Justin is an avid snowboarder and enjoys spending time outdoors. During his free time he will be found perusing the latest technology advancements and spending time with his family.',
    image: './img/leadership/justin.jpg',
    imagewebp: './img/leadership/justin.webp',
    mail: 'mailto:justin.kast@rrds.com',
  },
  pat: {
    name: 'Pat Brady',
    title: 'Director of Commercial Sales',
    about:
      'Patrick Brady oversees the RRDS commercial sales channel focused on providing premier procurement, logistics, and project management solutions to prime contractors supporting various government programs. He brings with him a diverse experience spanning 12 years in the Aerospace and Defense industry. A problem solver by nature, Pat plays a key role in providing deployment solutions for mission critical gear and services to customers facing supply chain challenges both domestically and abroad.<br/><br/>Pat comes from a military family and has great admiration for the veteran community. His father served as a Marine Corps Pilot, through which he was able to travel extensively living on various military bases. Through this, he gained first-hand experience of life as a service-member. After settling with his family in Virginia, Pat attended college at James Madison University where he studied International Affairs. He is passionate about serving our military and is always searching for innovative gear to enhance their mission capabilities while saving lives of those who serve.<br/><br/>Pat currently resides in San Diego and spends his free time surfing, traveling, outdoor activities, and enjoying time with friends and family.',
    image: './img/leadership/pat.jpg',
    imagewebp: './img/leadership/pat.webp',
    mail: 'mailto:pat.brady@rrds.com',
  },
};

const images = [
  fred,
  fredwebp,
  justin,
  justinwebp,
  pat,
  patwebp,
  samir,
  samirwebp,
  troy,
  troywebp,
];

const preloadImage = src => {
  return new Promise((res, rej) => {
    const img = new Image();
    img.addEventListener('load', () => res(src));
    img.addEventListener('error', err => rej(err));
    img.src = src;
  });
};

Promise.all(images.map(preloadImage)).then(images => {
  return;
});

let canIClickLeader = true;

const showCorrectLeader = leader => {
  const name = document.querySelector('.leadership__name');
  const title = document.querySelector('.leadership__title');
  const desc = document.querySelector('.leadership__desc');
  const email = document.querySelector('.leadership__main__contact');
  name.textContent = leadershipList[leader].name;
  title.textContent = leadershipList[leader].title;
  desc.innerHTML = leadershipList[leader].about;
  // email.setAttribute('href', leadershipList[leader].mail);

  // Update the image src and srcset inside the picture tag
  const pictureElement = document.querySelector('.leadership__main__image');
  const imgElement = pictureElement.querySelector('img');
  const webpSource = pictureElement.querySelector('source[type="image/webp"]');

  // Update the src and srcset attributes
  imgElement.src = leadershipList[leader].image;
  webpSource.srcset = leadershipList[leader].imagewebp;
  canIClickLeader = true;
};

const leaders = document.querySelectorAll('.leadership__thumb');
const leadersText = document.querySelectorAll('.leadership__selector li div');
const leaders__keyboard = document.querySelectorAll('.leadership__selector li');

const handleLeaderClick = (e, leader) => {
  let leaderSelected;

  // Check if e.target is the li and find the img inside
  if (e.target.tagName === 'LI') {
    leaderSelected = e.target.querySelector('img');
  }
  // Check if e.target is the li and find the img inside
  if (e.target.tagName === 'DIV') {
    leaderSelected = e.target.parentNode.querySelector('IMG');
  }

  // If e.target is directly the img, get data-leadership directly
  else if (e.target.tagName === 'IMG') {
    leaderSelected = leader;
  }
  if (
    canIClickLeader &&
    !leaderSelected.classList.contains('leadership__active')
  ) {
    canIClickLeader = false;
    const previousLeader = document.querySelector('.leadership__active');
    previousLeader.classList.remove('leadership__active');
    const story = document.querySelector('.leadership__main');
    leaderSelected.classList.add('leadership__active');
    const currentLeader = leaderSelected.dataset.leadership;
    showCorrectLeader(currentLeader);
    const storyPosition = story.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: storyPosition - 150,
      behavior: 'smooth',
    });
  }
};

leaders.forEach(leader => {
  leader.addEventListener('click', e => {
    e.preventDefault();
    handleLeaderClick(e, leader);
  });
});

leadersText.forEach(leader => {
  leader.addEventListener('click', e => {
    e.preventDefault();
    handleLeaderClick(e, leader);
  });
});

leaders__keyboard.forEach(leaders => {
  // Keydown event listener for Enter and Space
  leaders.addEventListener('keydown', e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleLeaderClick(e, leaders);
    }
  });
});
